import { render, staticRenderFns } from "./flowablePreviewWithXML.vue?vue&type=template&id=b8501cd0&scoped=true"
import script from "./flowablePreviewWithXML.vue?vue&type=script&lang=js"
export * from "./flowablePreviewWithXML.vue?vue&type=script&lang=js"
import style0 from "./flowablePreviewWithXML.vue?vue&type=style&index=0&id=b8501cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8501cd0",
  null
  
)

export default component.exports